import React from 'react';
import { Collapse } from 'antd';

const SbCollapse = (props) => <Collapse {...props} />;

export default SbCollapse;
